'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isAlwaysClosed;
function isAlwaysClosed(iterator) {
    if (!iterator.hasNext()) return false;

    var next = iterator.next();
    return next.status === 'unavailable' && !next.until;
}